import { useState, useEffect } from 'react';
import { ReembolsoSevices } from "../../Services/";

export const useMotivos = (poseeBoletos) => {
  const [motivos, setMotivos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    
    const fetchMotivos = async () => {
      setLoading(true);
      try {
        const boletoParam = poseeBoletos === "S" ? 0 : 1;
        const response = await ReembolsoSevices.ObtenerMotivos(boletoParam);
        
        if (isMounted) {
          if (response.status === 200 && response.resp != null) {
            setMotivos(response.resp);
          } else {
            setError('Error al cargar motivos');
          }
        }
      } catch (err) {
        if (isMounted) setError('Error de red al cargar motivos');
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchMotivos();
    
    return () => {
      isMounted = false;
    };
  }, [poseeBoletos]);

  return { motivos, loading, error };
};
